import { useState } from "react";
import { useRecoilState } from "recoil";
import myInfoState from "../../../atoms/myinfo";
import waitingRoomState from "../../../atoms/waiting-room";
import emitCreateRoom from "../../../connector/emits/createRoom";
import "./CreatingRoom.scoped.scss"
import { openAlert } from "../../../atoms/common";

function CreatingRoom() {
  const [myInfo] = useRecoilState(myInfoState);
  const [waitingRoom, setWaitingRoom] = useRecoilState(waitingRoomState);

  const [creatingRoomName, setCreatingRoomName] = useState('');
  const [creatingRoomMax, setCreatingRoomMax] = useState(10);
  const [creatingRoomIsPublic, setCreatingRoomIsPublic] = useState('1');
  const [creatingRoomPassword, setCreatingRoomPassword] = useState('');
  const [creatingRoomisProject, setCreatingRoomisProject] = useState('0');

  const optionsMaxParticipants = [10, 30, 50, 100, 300, 500, 1000];

  const closeThis = () => {
    setWaitingRoom({
      ...waitingRoom,
      isOpenedCreatingRoom: false,
    })
  }

  const onClickCreatingRoomButton = () => {
    const isProject = creatingRoomisProject === '1';

    if (myInfo.userDetail == null) {
      return;
    }
    // if (!isProject && myInfo.userDetail.level < 6) {
    //   openAlert('일반 채팅방은 픽스터레벨만 개설이 가능합니다.');
    //   return;
    // }
    // if (isProject && myInfo.userDetail.level < 6) {
    //   openAlert('프리미엄 채팅방은 픽스터레벨만 개설이 가능합니다.');
    //   return;
    // }    
    if (myInfo.standardTicket === 0) {
      openAlert('채팅방 개설권이 부족합니다.');
      return;
    }
    emitCreateRoom(
      creatingRoomName,
      '',
      creatingRoomMax,
      isProject,
      creatingRoomIsPublic === '0',
      creatingRoomPassword,
    );
  };

  return (
    <div className="creating-room-warpper">
      <div className="creating-room">
        <div className="creating-room__header">
          <div>채팅방 개설하기</div>
          <button onClick={closeThis}>X</button>
        </div>
        <div className="creating-room__contents">
          <div className="creating-room__row">
            <div className="creating-room__row-title">방제목</div>
            <div className="creating-room__row-input">
              <input 
                type="text" 
                value={creatingRoomName}
                onChange={(e) => setCreatingRoomName(e.target.value)}
              />
            </div>
          </div>
          <div className="creating-room__row">
            <div className="creating-room__row-title">방종류</div>
            <div className="creating-room__row-input" >
              <select value={creatingRoomisProject} onChange={(e) => setCreatingRoomisProject(e.target.value)}>
                <option value="0">일반</option>
                <option value="1">프리미엄</option>
              </select>
            </div>
          </div>
          <div className="creating-room__row">
            <div className="creating-room__row-title">공개여부</div>
            <div className="creating-room__row-input">
              <select value={creatingRoomIsPublic} onChange={(e) => setCreatingRoomIsPublic(e.target.value)}>
                <option value="1">공개</option>
                <option value="0">비공개</option>
              </select>
            </div>
          </div>
          {
            creatingRoomIsPublic === '0'
              ? (
                <div className="creating-room__row">
                  <div className="creating-room__row-title">비밀번호</div>
                  <div className="creating-room__row-input">
                    <input 
                      type="password"
                      value={creatingRoomPassword}
                      onChange={(e) => setCreatingRoomPassword(e.target.value)} 
                    />
                  </div>
                </div>
              )
              : null
          }
          <div className="creating-room__row">
            <div className="creating-room__row-title">참여인원</div>
            <div className="creating-room__row-input">
              <select 
                value={creatingRoomMax}
                onChange={(e) => setCreatingRoomMax(Number(e.target.value))}
              >
                {
                  optionsMaxParticipants.map(value => {
                    return (
                      <option value={value} key={value}>{value}명</option>
                    );
                  })
                }
              </select>
            </div>
          </div>
          <div className="creating-room__row">
            <div className="creating-room__row-title">채팅방 개설권</div>
            <div className="creating-room__row-input">
              <b>{myInfo.standardTicket}</b>개
              {/*<div>픽스터 레벨 부터 가능</div>*/}
            </div>
          </div>
          <div className="creating-room__row">
            <div className="creating-room__row-title">프리미엄 개설권</div>
            <div className="creating-room__row-input">
              <b>{myInfo.premiumTicket}</b>개
              {/*<div>픽스터 레벨 부터 가능</div>*/}
            </div>
          </div>
          <div className="creating-room__button">
            <button onClick={onClickCreatingRoomButton}>채팅방 개설하기</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreatingRoom;